import { TextAreaField } from "components/fields/base/TextAreaField";
import ToolTips from "utils/toolTips";
import { Flex } from "../../../../../../styled-system/jsx";
import { css } from "../../../../../../styled-system/css";

const AdPlanUpdateAnnotationField = ({ state, onChange }) => {
  return (
    <Flex className={css({ padding: "0 50px" })} gap="large" direction="column">
      <TextAreaField
        label={
          <span
            className={`${css({
              color: "#73706E",
            })} fs-standard`}
          >
            Comments (optional){" "}
            <ToolTips
              toolTip="If comments are added below a new annotation will be created. These annotations are shown on dashboard charts and in the Impact Analysis table."
              id="mediaPlanCustomUpdateAnnotationTooltip"
              position="top"
            />
          </span>
        }
        className={css({ width: "full" })}
        value={state.adUpdateAnnotation}
        onChange={(value) => onChange({ adUpdateAnnotation: value })}
        placeholder="Describe what changes you made..."
      />
    </Flex>
  );
};

export default AdPlanUpdateAnnotationField;
